export default "__VITE_ASSET__s_zySpGO__"